/* eslint-disable @typescript-eslint/explicit-function-return-type */

/**
 * Fixes problem with old browsers (e.g. Microsoft Edge before it went Chromium)
 * where the `flatMap` function is not supported.
 */
if (typeof Array.prototype.flatMap !== 'function') {
  const concat = (x, y) => x.concat(y);
  const flatMap = (f, xs) => xs.map(f).reduce(concat, []);

  Array.prototype.flatMap = function (f) {
    return flatMap(f, this);
  };
}
